import { ImagesAuthenticationCommonSpiritoryLogoSvg } from '@/assets/images_authentication_common.assets';
import Image from 'next/image';
import Link from 'next/link';

export default function OnBoardingHeader() {
  return (
    <div className="tw-py-4 tw-flex tw-items-center tw-justify-center">
      <Link href="/">
        <Image
          src={ImagesAuthenticationCommonSpiritoryLogoSvg}
          alt="Spiritory Logo"
          width={188}
          height={31.710844039916992}
          style={{
            height: 'auto',
          }}
        />
      </Link>
    </div>
  );
}
